// MUST be first: registers ArrayMap templates (initializeArrayMapRegistry) before
// combineReducers() below probes each reducer's init state — several reducers
// touch ArrayMapRegistry at that point. Importing it here makes the ordering an
// explicit module dependency instead of relying on bundler chunk/eval order.
import '../lib/init';
import { combineReducers } from 'redux';

import accountingConnections from './reducers/accountingConnectionReducer';
import activityCategories from './reducers/activityCategoryReducer';
import activityTypes from './reducers/activityTypeReducer';
import addresses from './reducers/addressReducer';
import answers from './reducers/answerReducer';
import bankAccounts from './reducers/bankAccountReducer';
import blackouts from './reducers/blackoutReducer';
import categories from './reducers/categoryReducer';
import campaigns from './reducers/campaignReducer';
import dockets from './reducers/docketReducer';
import matters from './reducers/matterReducer';
import comments from './reducers/commentReducer';
import caseTypes from './reducers/caseTypeReducer';
import caseTypeStages from './reducers/caseTypeStageReducer';
import deadlines from './reducers/deadlineReducer';
import deadlineRules from './reducers/deadlineRuleReducer';
import conflicts from './reducers/conflictReducer';
import contacts from './reducers/contactReducer';
import courts from './reducers/courtReducer';
import courtDeadlineRules from './reducers/courtDeadlineRuleReducer';
import discounts from './reducers/discountReducer';
import entityTimestamps from './reducers/entityTimestampReducer';
import documents from './reducers/documentReducer';
import expenses from './reducers/expenseReducer';
import events from './reducers/eventReducer';
import firms from './reducers/firmReducer';
import flatFees from './reducers/flatFeeReducer';
import flatFeeMilestones from './reducers/flatFeeMilestoneReducer';
import groups from './reducers/groupReducer';
import holidayCalendars from './reducers/holidayCalendarReducer';
import identifications from './reducers/identificationReducer';
import importExports from './reducers/importExportReducer';
import importSources from './reducers/importSourceReducer';
import invoices from './reducers/invoiceReducer';
import invoiceBatches from './reducers/invoiceBatchReducer';
import invoiceBatchItems from './reducers/invoiceBatchItemReducer';
import leads from './reducers/leadReducer';
import lookups from './reducers/lookupReducer';
import matterStages from './reducers/matterStageReducer';
import milestones from './reducers/milestoneReducer';
import options from './reducers/optionReducer';
import participants from './reducers/participantReducer';
import privileges from './reducers/privilegeReducer';
import questions from './reducers/questionReducer';
import redFlagTypes from './reducers/redFlagTypeReducer';
import redFlags from './reducers/redFlagReducer';
import resources from './reducers/resourceReducer';
import referrals from './reducers/referralReducer';
import roles from './reducers/roleReducer';
import tasks from './reducers/taskReducer';
import templateTasks from './reducers/templateTaskReducer';
import timeOffs from './reducers/timeOffReducer';
import transactions from './reducers/transactionReducer';
import users from './reducers/userReducer';
import alert from './reducers/alertReducer';
import calendar from './reducers/calendarReducer';
import contentBlock from './reducers/contentBlockReducer';
import misc from './reducers/miscReducer';
import savedStatus from './reducers/savedStatusReducer';
import statusBar from './reducers/statusBarReducer';

const app = combineReducers({
	accountingConnections,
	activityCategories,
	activityTypes,
	addresses,
	answers,
	bankAccounts,
	blackouts,
	categories,
	campaigns,
	dockets,
	matters,
	comments,
	caseTypes,
	caseTypeStages,
	deadlines,
	deadlineRules,
	conflicts,
	contacts,
	courts,
	courtDeadlineRules,
	discounts,
	entityTimestamps,
	documents,
	expenses,
	events,
	firms,
	flatFees,
	flatFeeMilestones,
	groups,
	holidayCalendars,
	identifications,
	importExports,
	importSources,
	invoices,
	invoiceBatches,
	invoiceBatchItems,
	leads,
	lookups,
	matterStages,
	milestones,
	options,
	participants,
	privileges,
	questions,
	redFlagTypes,
	redFlags,
	resources,
	referrals,
	roles,
	tasks,
	templateTasks,
	timeOffs,
	transactions,
	users,
	alert,
	calendar,
	contentBlock,
	misc,
	savedStatus,
	statusBar
});

export default app;